import { Address, ApiContext } from '../../types'
// import getCurrentBearerToken from '../authentication/getCurrentBearerToken'
import { serializeAddress } from '../serializers/address'
import getCurrentBearerToken from '@/api_client/api/authentication/getCurrentBearerToken'
// import getCurrentBearerToken from "@/api_client/api/authentication/getCurrentBearerToken";

export default async function addLogMultiProducts(
  { client, config }: ApiContext,
  ids: [],
  details: string,
): Promise<void> {
  const bearerToken = await getCurrentBearerToken({
    client,
    config,
  })

  const result = await client.tools.logMultiProducts(
    { bearerToken },
    { ids: ids, details: details },
  )

  if (result.isFail()) {
    console.log('result.fail()')
    console.log(result.fail())
    throw result.fail()
  }
}
